type Props = {
	value: string,
	onChange: (value: string) => void
}

export default function TokenInput({value, onChange}: Props) {
	return (
    <input
      type="text"
      value={value}
      onChange={(evt: React.ChangeEvent<HTMLInputElement>) => onChange((evt.target as HTMLInputElement).value)}
      placeholder="0.00"
      autoComplete="off"
      spellCheck="false"
      className="mr-4 w-1/2 flex-auto border-none bg-transparent p-0 text-4xl text-black dark:text-[#e8e8ee] placeholder:text-primary-200 lg:w-60 dark:placeholder:text-white/20"
    />
  );
}